import { questionPresentationContent } from "../../data/QuestionPresentation";
import { sortAnswers } from "../../pages/helpers";

function useAssumptionsRadioAndCheckboxQuestion({ question }) {
  const noDamageAnswer = question.answers[question.answers.length - 1];
  const noDamageAnswerID = noDamageAnswer.id;
  const answersForCheckbox = [...question.answers].slice(0, -1);
  const sortedAnswersForCheckbox = sortAnswers(answersForCheckbox);

  const {
    groupName,
    component: { content }
  } = questionPresentationContent[question.id];

  let showCheckboxLabel;
  let showCheckboxValue;
  let labelForCheckbox;

  if ("showCheckboxLabel" in content) {
    ({ showCheckboxLabel, showCheckboxValue, labelForCheckbox } =
      content);
  }

  return {
    noDamage: noDamageAnswerID,
    answersForCheckbox: sortedAnswersForCheckbox,
    groupName: groupName || "",
    questionString: question.content,
    noDamageLabel: noDamageAnswer.label,
    showCheckboxLabel,
    showCheckboxValue,
    labelForCheckbox
  };
}

export default useAssumptionsRadioAndCheckboxQuestion;
